import { Box, Card, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

// Stat tile: label, headline value, optional caption and a thin meter whose
// track is a light tint of the fill color.
const StatMeterCard = ({ label, value, caption, percent, color }) => {
  const clamped = Math.max(0, Math.min(100, Number(percent) || 0));
  return (
    <Card elevation={0} sx={{ p: 2.5, height: "100%", display: "flex", flexDirection: "column", gap: 1 }}>
      <Typography sx={{ fontSize: 13, color: "text.secondary" }}>{label}</Typography>
      <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, flexWrap: "wrap" }}>
        <Typography sx={{ fontSize: 28, fontWeight: 700, lineHeight: 1.2, color: "text.primary" }}>
          {value}
        </Typography>
        {caption && (
          <Typography sx={{ fontSize: 13, color: "text.secondary" }}>{caption}</Typography>
        )}
      </Box>
      {percent !== undefined && percent !== null && (
        <Box
          role="meter"
          aria-label={label}
          aria-valuenow={Math.round(clamped)}
          aria-valuemin={0}
          aria-valuemax={100}
          sx={{ mt: "auto", height: 6, borderRadius: 3, backgroundColor: alpha(color, 0.16) }}
        >
          <Box sx={{ width: `${clamped}%`, height: "100%", borderRadius: 3, backgroundColor: color }} />
        </Box>
      )}
    </Card>
  );
};

export default StatMeterCard;
